import moment from "moment/moment"
import { Template } from "../components/Template"
import {
  Alert,
  Backdrop,
  CircularProgress,
  Grid,
  Paper,
  TextField,
} from "@mui/material"
import { MyTable } from "../components/MyTable"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { SESSION_MODEL } from "../constants"
import { findAllSession, getSession } from "../store/features/sessionSlice"
import { SessionsForDayChart } from "../components/charts/log/SessionsForDayChart"
import { getAuth } from "../store/features/authSlice"

moment.locale("es")

export const LogsScreen = () => {
  const session = useSelector(getSession)
  const auth = useSelector(getAuth)
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [selected, setSelected] = useState({ ...SESSION_MODEL })
  const [filters, setFilters] = useState({
    user: "",
  })

  useEffect(() => {
    if (!!selected) {
      console.log(selected)
    }
  }, [selected])

  useEffect(() => {
    setPage(0)
    getAll()
  }, [filters])

  useEffect(() => {
    getAll()
  }, [page, rowsPerPage])

  const getAll = () => {
    dispatch(
      findAllSession({
        start: page,
        limit: rowsPerPage,
        user: filters.user,
        jwt: auth.data.jwtToken,
      })
    )
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const handleChangeFilter = (e) => {
    const name = e.target.name
    const value = e.target.value
    setFilters({ ...filters, [name]: value })
  }

  const columns = [
    {
      field: "id",
      headerName: "Id",
      width: 100,
      align: "left",
    },
    {
      field: "user",
      headerName: "Id de usuario",
      width: 100,
      align: "left",
    },
    {
      field: "userName",
      headerName: "Nombre de usuario",
      width: 300,
      align: "left",
      render: (params) => {
        const user = session.data.find(
          (item) => item.session.id === params.row.id
        ).user
        if (!user) return <></>
        else
          return (
            <>
              {user.personType === 1 && (
                <span>{user.name + " " + user.surname}</span>
              )}
              {user.personType === 2 && <span>{user.businessName}</span>}
            </>
          )
      },
    },
    {
      field: "host",
      headerName: "Host",
      width: 100,
      align: "left",
    },
    {
      field: "insertionDate",
      headerName: "Fecha",
      width: 200,
      align: "left",
      render: (params) => (
        <span>
          {moment(params.row.insertionDate).format("YYYY-MM-DD, hh:mm:ss a")}
        </span>
      ),
    },
  ]

  return (
    <Template>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <SessionsForDayChart />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ paddingY: 2 }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={10}>
              <TextField
                sx={{ marginRight: 1 }}
                label="Id de usuario"
                variant="outlined"
                name="user"
                value={filters.user}
                onChange={handleChangeFilter}
              />
            </Grid>
            <div style={{ marginLeft: 1 }}></div>
          </Grid>
          {session.status === "loading" && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={session.status === "loading"}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {session.status === "failed" && (
            <Alert severity="error">{String(session.error)}</Alert>
          )}
          {session.status === "succeeded" && (
            <div style={{ minHeight: 400, width: "100%" }}>
              <MyTable
                columns={columns}
                rows={session.data.map((item) => item.session)}
                page={page}
                handleChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                totalElements={session.totalElements}
              />
            </div>
          )}
        </Paper>
      </Grid>
    </Template>
  )
}
